import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AutoMLJobStats } from '../auto-ml/auto-mlbackend.service';
import { PaymentService, PaymentState } from '../payment.service';
import { AuthenticationService } from '../authentication/auth.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    standalone: false
})
export class DashboardComponent implements OnInit, OnDestroy {
  paymentState: PaymentState;
  private paymentChangeSubscription: Subscription;

  automlStats?: AutoMLJobStats;

  showMuwOnlyAcknowledgement = !!environment['showMuwStrings'];

  constructor(private paymentService: PaymentService, private router: Router, private http: HttpClient, private authService: AuthenticationService) { }

  ngOnDestroy(): void {
    if (this.paymentChangeSubscription)
      this.paymentChangeSubscription.unsubscribe();
  }

  ngOnInit() {
    if (!environment.hideInvoicingAndPayments) {
      this.loadPaymentState();

      this.paymentChangeSubscription = this.paymentService.changeSubject.subscribe(() => {
        this.loadPaymentState();
      });
    }

    this.authService.getFrontendConfig().then(async (feConfig) => {
      if ((await this.authService.hasOneOfClaims('canUseAutoml')) && feConfig.features?.enableAutoml) {
        this.loadAutomlQueueStats();
      }

      this.authService.getCanUseClaims().then(claims => {
        // if there is only one canUser... claim we forward the user to the corresponding page
        if (claims.length === 1) {
          switch (claims[0]) {
            /* Issue ACS-469 only talks about subtle demo so only this forward is currently active but the others can be uncommented if needed
            case 'canUseAutoml':
              if (feConfig.features?.enableAutoml) {
                this.router.navigateByUrl('/automl');
              }
              break;
            case 'canUseGenJobs':
              if (feConfig.features?.enableCdss) {
                this.router.navigateByUrl('/cdss');
              }
              break;
            case 'canUseRadiomics':
              if (feConfig.features?.enableRadiomics) {
                this.router.navigateByUrl('/radiomics');
              }
              break;
            */
            case 'canUseSubtleDemo':
            case 'canUseSubtleUnlimited':
              if (feConfig.features?.enableSubtleDemo) {
                this.router.navigateByUrl('/subtle-demo');
              }
              break;
          }
        }
      });
    });
  }

  loadPaymentState() {
    this.paymentService.getPaymentState().subscribe(paymentState => {
      this.paymentState = paymentState;
    });
  }

  private loadAutomlQueueStats() {
    this.http.get<AutoMLJobStats>(environment.baseUrl + '/automl-submission/stats').subscribe(stats => {
      this.automlStats = stats;
    });
  }

  showTransactions() {
    this.router.navigateByUrl("/dashboard/transactions");
  }

}

